import {NavigateFunction} from "react-router-dom";
import {getUserTokenOrRedirect} from "../../shared/services/auth.service";
import {
  AddEstimateCraneConnectionDto,
  EstimateCraneConnectionDto,
  UpdateEstimateCraneConnectionDto
} from "../../shared/dtos/estimate-crane-connection.dto";

const base = (estimateId: number) => `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/estimates/${estimateId}/crane_connections`;

export async function createCraneConnection(navigate: NavigateFunction, estimateId: number, connection: AddEstimateCraneConnectionDto): Promise<EstimateCraneConnectionDto> {
  const token = await getUserTokenOrRedirect(navigate);
  const response = await fetch(base(estimateId), {
    method: 'POST',
    headers: {Authorization: `Bearer ${token}`, 'Content-Type': 'application/json'},
    body: JSON.stringify(connection),
  });
  if (!response.ok) throw new Error(`Failed to connect the work item to the crane: ${response.statusText}`);
  return (await response.json()) as EstimateCraneConnectionDto;
}

export async function updateCraneConnection(navigate: NavigateFunction, estimateId: number, connectionId: number, connection: UpdateEstimateCraneConnectionDto): Promise<EstimateCraneConnectionDto> {
  const token = await getUserTokenOrRedirect(navigate);
  const response = await fetch(`${base(estimateId)}/${connectionId}`, {
    method: 'PATCH',
    headers: {Authorization: `Bearer ${token}`, 'Content-Type': 'application/json'},
    body: JSON.stringify(connection),
  });
  if (!response.ok) throw new Error(`Failed to move the staging pile: ${response.statusText}`);
  return (await response.json()) as EstimateCraneConnectionDto;
}

export async function deleteCraneConnection(navigate: NavigateFunction, estimateId: number, connectionId: number): Promise<void> {
  const token = await getUserTokenOrRedirect(navigate);
  const response = await fetch(`${base(estimateId)}/${connectionId}`, {
    method: 'DELETE',
    headers: {Authorization: `Bearer ${token}`, 'Content-Type': 'application/json'},
  });
  if (!response.ok) throw new Error(`Failed to disconnect the work item from the crane: ${response.statusText}`);
}
